import { Methods } from '@newview/infrastructure';
import {BasicDataBaseApi} from "./BasicDataBaseApi";


export class BusinessworkflowstepApi extends BasicDataBaseApi {

  public get ControllerName(): any {
    return 'businessworkflowstep'
  }

  /**
   * 分页获取
   * @param params
   */
  public getListByWfId(wfId){
    return this.send({wfId:wfId},"getListByWfId",Methods.GET)
  }
 
  
 

  
 

}